import {EventEmitter, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Permission} from '../interface/permission';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private baseUrl = environment.apiBaseUrl;
  permissionsChanged = new EventEmitter<void>();

  constructor(private http: HttpClient) { }

  getCollection(): Observable<Permission[]> {
    return this.http.get<Permission[]>(`${this.baseUrl}/get/permissions`);
  }
  getEnableCollection(): Observable<Permission[]> {
    return this.http.get<Permission[]>(`${this.baseUrl}/get/enable/permissions`);
  }

  post(data: Permission): Observable<any>{
    return this.http.post(`${this.baseUrl}/create/permission`, data);
  }

  put(id: number, data: Permission): Observable<any>{
    return this.http.put(`${this.baseUrl}/edit/permission/${id}`, data);
  }

  delete(id: number): Observable<any>{
    return this.http.delete(`${this.baseUrl}/delete/permission/${id}`);
  }

  getPermissionListById(id: number): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/permission/${id}`);
  }

  deleteMultiple(ids: number[]): Observable<Permission[]>{
    const options = {body: ids};
    return this.http.delete<any>(`${this.baseUrl}/delete/selected/permission`, options);

  }

  refreshPermissions() {
    this.permissionsChanged.emit();
  }
}
